import { render } from "./Stackrel.vue?vue&type=template&id=6238be7d&scoped=true"
import script from "./Stackrel.vue?vue&type=script&lang=js"
export * from "./Stackrel.vue?vue&type=script&lang=js"

import "./Stackrel.vue?vue&type=style&index=0&id=6238be7d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6238be7d"

export default script